import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ActivatedRoute, Params, Route, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectAllCarImagesFolders, selectAllSearchedDealers, selectAllSearchedDealersPreviewTotalCount, selectDealerFavorites, selectDealerCriteria, selectSearchFetchingResults } from 'src/app/common/store/state/app.state';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { DealerCriteria } from '../../models/dealer-criteria.model';
import { Dealer } from '../../models/dealer.model';
import { DealerSearchCriteriaComponent } from '../dealer-search-criteria/dealer-search-criteria.component';
import { DealersComponent } from '../dealers/dealers.component';
import { MatSelectModule } from '@angular/material/select';


@Component({
    selector: 'app-dealer-search',
    templateUrl: './dealer-search.component.html',
    styleUrls: ['./dealer-search.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatFormFieldModule, MatDialogModule, MatIconModule, MatProgressSpinnerModule, MatIconModule, MatDividerModule, AsyncPipe, DealerSearchCriteriaComponent, DealersComponent, MatSelectModule]
})
export class DealerSearchComponent implements OnInit {
  
  previewTotalCount$: Observable<number>;
  searchCriteria$: Observable<DealerCriteria>;

  fetchingResults$: Observable<boolean>;

  dealerResults$: Observable<Dealer[]>;
  dealerResults: Dealer[] = [];

  //count$: Observable<number>;

  carImagesFolders$: Observable<Map<string, Array<FileData>>>;

  dealerCriteria: DealerCriteria = new DealerCriteria();
  pageNumber: number = 0;
  pageSize: number = AppConstants.PAGE_SIZE_DEFAULT;
  pageNumbers: number [] = [ 1 ];

  totalItems: number = 0;
  pageSizeOptions = AppConstants.PAGE_SIZE_OPTIONS;

  dealersFetched: boolean = false;
  parameters?: Params;

  objectSource: ObjectSource = ObjectSource.SEARCH

  constructor(

    private store: Store, 
    private route: ActivatedRoute,
    router: Router
    ) {

      this.searchCriteria$ = store.select(selectDealerCriteria);
      this.previewTotalCount$ = store.select(selectAllSearchedDealersPreviewTotalCount);

      this.fetchingResults$ = store.select(selectSearchFetchingResults);
      this.dealerResults$ = store.select(selectAllSearchedDealers);
      //this.count$ = store.select(selectAllSearchedCarsCount);

      this.carImagesFolders$ = store.select(selectAllCarImagesFolders);

      this.searchCriteria$.subscribe(criteria => {
        this.dealerCriteria = criteria;
        this.pageSize = this.dealerCriteria.pageSize;
        this.pageNumbers = Array(Math.ceil(this.totalItems/this.dealerCriteria.pageSize)).fill(0).map((x,i)=>i);
      });

      route.queryParams.subscribe(params => {

        //let temp = JSON.parse(JSON.stringify(params));
        console.log("params = "+JSON.stringify(params));
        this.parameters = params;

        //let temp = Object.assign(new DealerCriteria(), params);
        let crt: DealerCriteria = new DealerCriteria();
        AppFunctions.replaceValues(crt, params);

        console.log("criteria 1= "+JSON.stringify(crt));

        this.store.dispatch(SearchActions.dealerCriteriaSubmit({dealerCriteria: crt}));

      });

    }

    ngOnInit() {

      this.previewTotalCount$.subscribe(total => {
        this.totalItems = total;
        //this.pageNumbers = Array(Math.ceil(this.totalItems/this.dealerCriteria.pageSize)).fill(0).map((x,i)=>i);
      });

      if(!this.dealersFetched){
        
        //let crt: DealerCriteria = JSON.parse(JSON.stringify(this.dealerCriteria));
        let crt: DealerCriteria = new DealerCriteria();
        AppFunctions.replaceValues(crt, this.parameters);

        console.log("criteria 22 = "+JSON.stringify(crt));
        this.store.dispatch(SearchActions.dealerCriteriaSubmit({dealerCriteria: crt}));
        this.dealersFetched = true;

      } 

      this.dealerResults$.subscribe(
        (res: Dealer[]) =>  {
          this.dealerResults = res.map(c => Object.assign(new Dealer(), c));
        }
      );
  }

  loadPreviousPage(){
    if(this.pageNumber > 0){
      this.pageNumber --;
      this.dispatchEvent();
    }
  }

  loadNextPage(){
    if(this.pageNumber < this.totalItems/this.pageSize - 1){
      this.pageNumber ++;
      this.dispatchEvent();
    } 
  }

  loadPage(pgNum: number){

      this.pageNumber = pgNum;
      this.dispatchEvent();
    
  }

  updatePageSize(){
    this.pageNumber = 0;
    this.dispatchEvent();
  }
  
  dispatchEvent(){

    let crt = JSON.parse(JSON.stringify(this.dealerCriteria));
    crt.pageSize = this.pageSize;
    crt.pageNumber = this.pageNumber;
    this.store.dispatch(SearchActions.dealerCriteriaSubmit({dealerCriteria: crt}));
  }
  
}
